<template>
  <div id="page-applicant-show">
    <vs-alert
      color="danger"
      title="Bewerber nicht gefunden"
      :active.sync="fetchFailed"
    >
      <span>Bewerber mit ID: {{ $route.params.id }} nicht gefunden.</span>
      <span>
        <span> Gehe zu </span
        ><router-link
          :to="{ name: 'applicant.overview' }"
          class="text-inherit underline"
          >Alle Bewerber</router-link
        >
      </span>
    </vs-alert>
    <template v-if="$store.getters['user/hasPermission']('cv_parsing')">
      <vs-alert
        color="danger"
        title="Bewerberdaten werden übertragen"
        :active.sync="cvTransferInProgress"
      >
        <span
          >Eine datei wurde erfolgreich analysiert und wird nun übertragen.
          Bitte verlassen Sie die Seite nicht</span
        >
      </vs-alert>
      <vs-alert
        title="Lebenslauf wird analysiert"
        :active.sync="cvAnalysisInProgress"
      >
        <span
          >Ein Lebenslauf wird analysiert. Sie werden benachrichtigt, sobald die
          Analyse Abgeschlossen ist.</span
        >
      </vs-alert>
    </template>
    <button class="goBack-btn" @click="goBack">
      <i class="fal fa-arrow-left"></i>Zurück
    </button>
    <div
      v-if="applicant && applicantProfile"
      class="vx-row w-full applicant-show"
    >
      <div class="vx-col w-full lg:w-2/3">
        <div class="card big">
          <div class="card-header">
            <div class="vx-row">
              <div
                v-if="applicant.imageID"
                class="
                  vx-col
                  w-7/12
                  md:w-2/12
                  lg:w-2/12
                  applicant-show-image-col
                "
              >
                <AuthImage v-if="applicant.imageID" :src="applicant.imageID" />
              </div>
              <div
                v-else
                class="
                  vx-col
                  w-7/12
                  md:w-2/12
                  lg:w-2/12
                  applicant-show-image-col
                "
              >
                <img src="@/assets/images/elements/anonymous.png" />
              </div>
              <div class="vx-col w-full md:w-7/12 lg:w-7/12">
                <div class="applicant-show-number">#{{ applicant.number }}</div>
                <div class="applicant-show-name">
                  <template v-if="applicant.salutation == `MR`">Herr</template>
                  <template v-else-if="applicant.salutation == `MRS`"
                    >Frau</template
                  >
                  {{ applicant.firstName }} {{ applicant.lastName }}
                  <span v-if="applicant.birthday">{{
                    getAge(applicant.birthday)
                  }}</span>
                </div>
                <div class="applicant-show-infos">
                  <ul>
                    <li v-if="applicant.contactData.address">
                      <i class="fal fa-map-marker-alt"></i>
                      <template v-if="applicant.contactData.address.street"
                        >{{ applicant.contactData.address.street }}, &nbsp;
                      </template>
                      <template v-if="applicant.contactData.address.zip">
                        {{ applicant.contactData.address.zip }} &nbsp;</template
                      >
                      <template v-if="applicant.contactData.address.city">
                        {{ applicant.contactData.address.city }}</template
                      >
                    </li>
                    <li v-if="applicant.contactData.email">
                      <i class="fal fa-envelope"></i
                      ><a :href="` mailto:${applicant.contactData.email} `">{{
                        applicant.contactData.email
                      }}</a>
                    </li>
                    <li v-if="applicant.contactData.telephoneMobile">
                      <i class="fal fa-phone-alt"></i>
                      <a
                        :href="
                          ` callto:${applicant.contactData.telephoneMobile} `
                        "
                        >{{ applicant.contactData.telephoneMobile }}</a
                      >
                    </li>
                    <li v-else-if="applicant.contactData.telephone">
                      <i class="fal fa-phone-alt"></i>
                      <a
                        :href="` callto:${applicant.contactData.telephone} `"
                        >{{ applicant.contactData.telephone }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Card-Header Sidebar -->
              <div class="vx-col w-full md:w-3/12 lg:w-3/12">
                <div
                  v-if="
                    applicant.defaultProfile &&
                      applicant.defaultProfile.wantedJobTypes &&
                      applicant.defaultProfile.wantedJobTypes[0]
                  "
                  class="grid grid-cols-2 gap-4 mb-5"
                >
                  <div></div>
                  <div v-if="isPv()" class="applicant-show-job-type">
                    <span class="applicant-show-job-type-badge">PV</span>
                    <div class="applicant-show-job-type-title">Stellenart</div>
                  </div>
                  <div v-else class="applicant-show-job-type">
                    <span class="applicant-show-job-type-badge">AÜ</span>
                    <div class="applicant-show-job-type-title">Stellenart</div>
                  </div>
                </div>
                <template v-if="!applicant.privacyPolicyAccepted">
                  <div class="applicant-show-privacyPolicy">
                    <i
                      class="fas fa-exclamation-triangle"
                      title="Datenschutzerklärung fehlt!"
                    ></i>
                    Datenschutz nicht bestätigt
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="currentProfileId" slot="no-body" class="tabs-container">
              <vs-tabs
                v-model="currentTab"
                class="tab-action-btn-fill-conatiner"
              >
                <!-- <vs-tab label="Dashboard">
                  <div v-if="tabs[currentTab] === 'data'" class="tab-text">
                    <Dashoard :profile-id="currentProfileId" />
                  </div>
                </vs-tab> -->
                <vs-tab label="Persönliche Daten">
                  <div v-if="tabs[currentTab] === 'profile'" class="tab-text">
                    <Dashoard :profile-id="applicantProfile.id" />
                    <Accordion>
                      <accordion-item>
                        <template slot="accordion-trigger"
                          >Persönliche Daten</template
                        >
                        <template slot="accordion-content">
                          <PersonalData
                            :profile-id="applicantProfile.id"
                            @saved="formSaved"
                          />
                        </template>
                      </accordion-item>
                      <accordion-item>
                        <template slot="accordion-trigger"
                          >Beworben als</template
                        >
                        <template slot="accordion-content">
                          <ApplicationAs
                            :profile-id="applicantProfile.id"
                            @saved="formSaved"
                          />
                        </template>
                      </accordion-item>
                      <accordion-item>
                        <template slot="accordion-trigger">Bewerbung</template>
                        <template slot="accordion-content">
                          <Application :profile-id="applicantProfile.id" />
                        </template>
                      </accordion-item>
                      <accordion-item>
                        <template slot="accordion-trigger">Intern</template>
                        <template slot="accordion-content">
                          <InternalData
                            :profile-id="applicantProfile.id"
                            @saved="formSaved"
                          />
                        </template>
                      </accordion-item>
                    </Accordion>
                  </div>
                </vs-tab>
                <vs-tab label="Dokumente">
                  <div v-if="tabs[currentTab] === 'docs'" class="tab-text">
                    <Documents
                      :profile-id="applicantProfile.id"
                      @cv-analysis-complete="updateApplicantFromCV"
                      @cv-analysis-started="
                        x => {
                          cvAnalysisInProgress = x;
                        }
                      "
                    />
                  </div>
                </vs-tab>
                <vs-tab label="Aktivitäten">
                  <div v-if="tabs[currentTab] === 'history'" class="tab-text">
                    <InternalHistory :profile-id="applicantProfile.id" />
                    <Resubmissions :profile-id="applicantProfile.id" />
                  </div>
                </vs-tab>
                <vs-tab label="Lebenslauf">
                  <div v-if="tabs[currentTab] === 'cv'" class="tab-text">
                    <CV :profile-id="applicantProfile.id" />
                  </div>
                </vs-tab>
                <vs-tab label="Export">
                  <div v-if="tabs[currentTab] === 'export'" class="tab-text">
                    <Accordion>
                      <accordion-item>
                        <template slot="accordion-trigger">PDF Profil</template>
                        <template slot="accordion-content">
                          <InternalProfile
                            :profile-id="applicantProfile.id"
                            @saved="formSaved"
                          />
                        </template>
                      </accordion-item>
                      <accordion-item>
                        <template slot="accordion-trigger">L1</template>
                        <template slot="accordion-content">
                          <L1 />
                        </template>
                      </accordion-item>
                      <accordion-item
                        v-if="
                          $store.getters['user/hasPermission'](
                            'cleverreach_applicants'
                          )
                        "
                      >
                        <template slot="accordion-trigger"
                          >Cleverreach</template
                        >
                        <template slot="accordion-content">
                          <applicant-data-sync :applicant-id="applicant.id" />
                        </template>
                      </accordion-item>
                    </Accordion>
                  </div>
                </vs-tab>
                <vs-tab label="Kenntnisse">
                  <div v-if="tabs[currentTab] === 'knowledge'" class="tab-text">
                    <Knowledge
                      :profile-id="currentProfileId"
                      @saved="formSaved"
                    />
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </div>
      </div>
      <!-- Sidebar -->
      <div class="vx-col w-full lg:w-1/3">
        <div
          class="
            grid grid-cols-2
            lg:grid-cols-6
            gap-4
            applicant-show-grid-group
          "
        >
          <div class="col-span-2 lg:col-span-3">
            <div class="card card-type-status">
              <div class="card-body">
                <div class="circle-wrapper">
                  <span title="Eingestellt" class="circle green"></span><br />
                  <span title="In Bearbeitung" class="circle yellow"></span
                  ><br />
                  <span title="Offen" class="circle red"></span>
                </div>
                <div>
                  Status:<br />
                  <span
                    v-if="applicantProfile.state && applicantProfile.state.name"
                    class="card-type-status-text"
                    :class="getStateColor(applicantProfile.state.name)"
                    >{{ applicantProfile.state.name }}</span
                  >
                  <span v-else class="card-type-status-text red"
                    >Keine Angabe</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="card card-type-action">
            <div class="card-body">
              <button @click="toggleSelection('action1')">
                <i class="fal fa-file-pdf"></i>
              </button>
              <div v-if="openSelection == 'action1'" class="pdf-selection">
                <select
                  id="template"
                  name="template"
                  @change="templateChange()"
                >
                  <option value="Profil-AUE">PDF Profil (AÜ)</option>
                  <option value="Profil-PV">PDF Profil (PV)</option>
                </select>
                <button class="mt-2" @click="downloadPdf">PDF Erstellen</button>
              </div>
            </div>
          </div>
          <!-- <div class="card card-type-action">
            <div class="card-body">
              <button @click="toggleSelection('action2')">
                <i class="fal fa-file-spreadsheet"></i>
              </button>
              <div v-if="openSelection == 'action2'" class="pdf-selection">
                <button class="mt-2" @click="applicantDataForm">
                  Bewerberbogen
                </button>
                <button class="mt-2" @click="applicantSkillForm">
                  Skillbogen
                </button>
              </div>
            </div>
          </div> -->
          <div class="col-span-2 card card-type-action">
            <div class="card-body l1-sync">
              <img
                src="@/assets/images/logo/zvoove_icon.svg"
                style="max-height: 46px;"
              />
              <template v-if="applicant.l1ID"
                ><span class="l1-sync-icon green"
                  ><i class="far fa-check"></i></span
              ></template>
              <template v-else
                ><span class="l1-sync-icon red"
                  ><i class="far fa-times"></i></span
              ></template>
            </div>
          </div>
        </div>
        <div v-if="applicant.latestApplication" class="card application-card">
          <div class="card-body">
            <div class="application-card-title">
              <i class="fal fa-calendar-alt"></i>Bewerbung am
              {{ $d(new Date(applicant.latestApplication.createdAt), "short") }}
            </div>
            <ul class="application-card-content">
              <li
                v-if="
                  applicant.latestApplication.vacancy &&
                    applicant.latestApplication.vacancy.title
                "
              >
                <span><i class="fas fa-swords-laser"></i></span
                >{{ applicant.latestApplication.vacancy.title }}
              </li>
              <li
                v-if="
                  applicant.latestApplication.project &&
                    applicant.latestApplication.project.company &&
                    applicant.latestApplication.project.company.name
                "
              >
                <span><i class="fal fa-building"></i></span
                >{{ applicant.latestApplication.project.company.name }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="card application-card">
          <div class="card-body">
            <div class="application-card-title mb-0">
              <i class="fal fa-calendar-alt"></i>Angelegt am
              {{ $d(new Date(applicant.createdAt), "short") }}
            </div>
          </div>
        </div>
        <div
          v-if="applicant && applicant.defaultProfile"
          class="card interview-card"
        >
          <div class="card-body">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/2">
                <div class="card-headline">Interviewnotizen</div>
              </div>
              <div class="vx-col w-full md:w-1/2">
                <div
                  v-if="applicant.defaultProfile.interviewNoteUpdatedAt"
                  class="interview-card-date"
                >
                  <i class="fal fa-calendar-alt"></i>
                  {{
                    $d(
                      new Date(applicant.defaultProfile.interviewNoteUpdatedAt),
                      "long"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="interview-card-input">
              <DataInput
                v-model="applicant.defaultProfile.interviewNote"
                type="html"
                class="w-full"
                name="interview"
              />
              <button
                class="interview-card-input-save"
                @click="saveInterviewData"
              >
                <i class="fas fa-save"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card actions-card">
          <div class="card-body">
            <div class="card-headline">Historie</div>
            <div class="actions-card-body">
              <ShortActions
                is-history
                type="APPLICANT"
                :resource-id="$route.params.id"
              />
              <div class="actions-card-more" @click="showHistoryRoute">
                Vollständige Historie ansehen<i class="fas fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="applicant" class="shadow-none">
      <router-link
        v-if="applicant.contactData.telephoneMobile"
        id="quick-sms"
        :to="{
          name: 'applicant.shortMessager',
          params: { id: $route.params.id }
        }"
      >
        <i class="fas fa-sms"></i>
      </router-link>
      <router-link
        id="quick-mail"
        :to="{ name: 'applicant.mailer', params: { id: $route.params.id } }"
      >
        <i class="fa fa-envelope"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import PdfExport from "../pdf";
import ApplicantDataSync from "./ApplicantDataSync.vue";
import debug from "../../../helpers/debug";
import CivilStatus from "../../../data/enums/CivilStatus.js";
import Countries from "@/data/other/Countries.js";
import editFormMixin from "@/mixins/editFormMixin.js";
import AuthImage from "@/components/ui/AuthImage";
import DataInput from "@/components/ui/DataInput";

import Dashoard from "./ApplicantShowDashboard";
import ShortActions from "@/components/applicant/ApplicantShowShortHistory";
import Resubmissions from "./ApplicantShowResubmissions";
import InternalHistory from "./ApplicantShowInternalHistory";
import ApplicationAs from "./ApplicantShowApplicationAs";
import Application from "./ApplicantShowApplication";
import PersonalData from "./ApplicantShowPersonalData";
import CV from "./ApplicantShowCV";
import Documents from "./ApplicantShowDocuments";
import InternalData from "./ApplicantShowInternalData";
import InternalProfile from "./ApplicantShowInternalProfile";
import Knowledge from "./ApplicantShowKnowledge";
import L1 from "./ApplicantL1";
import CountriesISO from "../../../data/other/CountriesISO";

import Accordion from "@/components/ui/Accordion";
import AccordionItem from "@/components/ui/Accordion-Item";

export default {
  components: {
    Application,
    ApplicationAs,
    CV,
    Documents,
    InternalData,
    InternalHistory,
    InternalProfile,
    Knowledge,
    L1,
    Dashoard,
    Resubmissions,
    ApplicantDataSync,
    AuthImage,
    DataInput,
    ShortActions,
    PersonalData,
    Accordion,
    AccordionItem
  },
  mixins: [
    editFormMixin({
      methodSuffix: "Applicant",
      idFields: ["entryType", "group"],
      ignoredFields: ["user", "privacyPolicyRequestedDate"],
      legacyIDFields: ["source"]
    })
  ],
  data() {
    document.setDebugCookie = value =>
      debug.setCookie("promatch_debug_mode", value, 100);
    return {
      lastSave: new Date(),
      fetchFailed: false,
      currentTab: 0,
      selectedProfile: null,
      tabs: ["profile", "docs", "history", "cv", "export", "knowledge"],
      cvAnalysisInProgress: false,
      cvTransferInProgress: false,
      interview: null,
      template: "Profil-AUE",
      openPdfSelection: false,
      openSelection: false
    };
  },

  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            number
            salutation
            firstName
            lastName
            birthday
            birthplace
            privacyPolicyAccepted
            privacyPolicyAcceptedDate
            kids
            civilStatus
            nationality
            l1ID
            createdAt
            imageID
            defaultProfile {
              id
              wantedOccupation
              interviewNote
              interviewNoteUpdatedAt
              skillJobType {
                id
              }
              wantedJobTypes {
                id
                name
              }
            }
            contactData {
              email
              telephone
              telephoneMobile
              address {
                street
                zip
                city
              }
            }
            source {
              id
              name
            }
            profiles {
              id
              title
              isDefault
            }
            latestApplication {
              id
              createdAt
              project {
                id
                company {
                  id
                  name
                }
              }
              vacancy {
                id
                title
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      error(error) {
        if (error.gqlError.message === "record not found") {
          this.fetchFailed = true;
        } else {
          this.fetchFailed = true;
          // TODO: Display different error message
        }
      }
    },
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            state {
              id
              name
            }
          }
        }
      `,
      skip() {
        return !this.applicant;
      },
      variables() {
        return {
          id: this.applicant.defaultProfile.id
        };
      }
    },
    me: {
      query: gql`
        query Me {
          me {
            id
            consultant {
              id
            }
            group {
              id
            }
          }
        }
      `
    }
  },
  computed: {
    currentProfileId: {
      get() {
        if (!this.applicant || !this.applicant.profiles) return;
        if (this.selectedProfile) return this.selectedProfile;

        //console.log(this.applicant.profiles);
        const profile = this.applicant.profiles.find(v => v.isDefault);

        return profile ? profile.id : null;
      },
      set(v) {
        //console.log(v);
        this.selectedProfile = v;
      }
    }
  },
  watch: {
    currentTab(tab) {
      if (this.$route.params.page !== this.tabs[tab]) {
        this.$router.replace({
          name: "applicant.show.sub",
          params: { page: this.tabs[tab] }
        });
      }
    },
    "applicant.profiles": function() {
      //console.log(value);
    }
  },
  mounted() {
    if (this.$route.params.page) {
      this.currentTab = this.tabs.indexOf(this.$route.params.page);
    }
  },
  methods: {
    async updateApplicantFromCV(cvData) {
      let $this = this;
      if (!this.$store.getters["user/hasPermission"]("cv_parsing")) {
        return;
      }
      const documentID = cvData.documentID;
      const oldSource = this.applicant.source.id;
      this.cvTransferInProgress = true;
      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };
      let notParseable = "";
      const cvEntryTypes = await this.$apollo
        .query({
          query: gql`
            {
              applicantCvEntryTypes(page: 1, size: 100) {
                results {
                  id
                  name
                }
              }
            }
          `
        })
        .then(({ data }) => {
          //console.log(data);
          return Object.fromEntries(
            data.applicantCvEntryTypes.results.map(x => [x.name, x.id])
          );
        });
      const applicantSources = await this.$apollo
        .query({
          query: gql`
            {
              applicantSources(page: 1, size: 1000) {
                results {
                  id
                  name
                }
              }
            }
          `
        })
        .then(({ data }) =>
          Object.fromEntries(
            data.applicantSources.results.map(x => [x.nam, x.id])
          )
        );
      function getValueAt(obj, key) {
        //console.log(obj, key);
        let keyArray = key
          .split(".")
          .map(x => x.split("[").map(y => y.replace("[", "")))
          .flat(3)
          .map(str => {
            if (!isNaN(str) && !isNaN(parseFloat(str))) {
              return parseInt(str);
            } else {
              return str;
            }
          });
        //console.log(keyArray);
        try {
          let current = obj;
          for (let k of keyArray) {
            current = current[k];
          }
          //console.log(current);
          return current;
        } catch {
          //console.log(obj, key);
          return null;
        }
      }
      function tryDo(func) {
        try {
          return func();
        } catch (err) {
          console.log("Warning: problem updating objects: ", err); //eslint-ignore-line
        }
      }
      async function newApplicantData(cvData) {
        //console.log(cvData);
        notParseable += [
          "",
          ...[cvData.CustomArea, cvData.Hobbies, cvData.skills].map(x =>
            JSON.stringify(x)
          )
        ];
        return {
          firstName:
            (getValueAt(cvData, "personal.firstName") || "") +
            (getValueAt(cvData, "personal.middleName")
              ? " " + getValueAt(cvData, "personal.middleName")
              : ""),
          lastName: getValueAt(cvData, "personal.lastName"),
          birthday: moment(getValueAt(cvData, "personal.birthDate")),
          salutation: tryDo(() => {
            const genderDescription = getValueAt(
              cvData,
              "personal.gender.description"
            );
            if (genderDescription == "Male") {
              return "MR";
            } else if (genderDescription == "Female") {
              return "MRS";
            } else {
              return undefined;
            }
          }),
          contactData: {
            email:
              tryDo(
                () =>
                  (getValueAt(cvData, "personal.emails") || []).map(
                    x => x.email
                  )[0]
              ) || null,
            telephone: tryDo(() => {
              for (const phone of getValueAt(cvData, "personal.phones") || []) {
                if (phone.type == "home") {
                  return phone.number;
                }
              }
            }),
            telephoneMobile: tryDo(() => {
              for (const phone of getValueAt(cvData, "personal.phones") || []) {
                if (phone.type == "mobile") {
                  return phone.number;
                }
              }
            }),
            address: {
              street:
                getValueAt(cvData, "personal.address.street") +
                " " +
                getValueAt(cvData, "personal.address.number"),
              city: getValueAt(cvData, "personal.address.city"),
              zip: getValueAt(cvData, "personal.address.postalCode"),
              country: tryDo(() => {
                const countryCode = getValueAt(
                  cvData,
                  "personal.address.country.code"
                );
                return CountriesISO.find(function(val) {
                  return val.ISO2 == countryCode;
                }).internalCode;
              }),
              lat: Number(getValueAt(cvData, "personal.address.latitude")),
              lng: Number(getValueAt(cvData, "personal.address.longitude"))
            }
          },
          nationality: getValueAt(cvData, "nationality.code"),
          imageID: await tryDo(async () => {
            if (cvData.profilePicture && cvData.profilePicture.base64Content) {
              let formData = new FormData();
              const file = b64toBlob(
                cvData.profilePicture.base64Content,
                cvData.profilePicture.contentType
              );
              formData.append("file", file, cvData.profilePicture.fileName);
              formData.append("is_public", true);
              try {
                const response = await $this.$axiosStorageApi.post(
                  "/file/upload_auth",
                  formData
                );
                return response.id;
              } catch {
                notParseable += "\nProfilbild";
              }
            }
          })
        };
      }
      function newApplicantProfile(cvData, cvEntries) {
        return {
          cvEntries: tryDo(() => {
            if (!cvEntries) {
              cvEntries = [];
            }
            let latestEndDate = null;
            function setLatestEndDate(newDate) {
              if (!latestEndDate) {
                latestEndDate = newDate;
                return;
              }
              latestEndDate = latestEndDate > newDate ? latestEndDate : newDate;
            }
            for (const degree of getValueAt(
              cvData,
              "educationHistory.degrees"
            ) || []) {
              cvEntries.push({
                type:
                  cvEntryTypes[
                    {
                      "Secondary Education": "Schule",
                      "Primary Education": "Schule",
                      "Vocational Education": "Ausbildung"
                    }[degree.internationalDescription] || "Studium"
                  ],
                applicant: $this.$route.params.id,
                dateFrom: degree.startDate,
                dateUntil: degree.endDate,
                employer: (degree.institute + " " + degree.location).trim(),
                position: degree.degreeName
              });
              setLatestEndDate(degree.endDate);
            }
            for (const course of cvData.courses || []) {
              cvEntries.push({
                type: cvEntryTypes["Weiterbildung"],
                position: course.courseName,
                dateUntil: course.endDate,
                dateFrom: course.startDate,
                employer: (course.institute + " " + course.location).trim(),
                applicant: $this.$route.params.id
              });
              setLatestEndDate(course.endDate);
            }
            //console.log(cvEntryTypes);
            for (const employment of cvData.employmentHistory || []) {
              let type = cvEntryTypes["Berufserfahrung"];
              if (employment.jobTitle == "Zivildienst") {
                type = cvEntryTypes["Bundeswehr / Zivildienst"];
              }
              cvEntries.push({
                type,
                dateUntil: employment.endDate,
                dateFrom: employment.startDate,
                employer: (
                  employment.organization +
                  " " +
                  employment.location
                ).trim(),
                applicant: $this.$route.params.id,
                position: employment.jobTitle,
                description: employment.description
              });
              setLatestEndDate(employment.endDate);
            }
            if (cvData.summary.currentJob) {
              let currentJobSet = false;
              for (let cvEntry of cvEntries) {
                if (
                  !cvEntry.id &&
                  cvEntry.dateUntil == latestEndDate &&
                  cvEntry.position == cvData.summary.currentJob
                ) {
                  cvEntry.dateUntil = null;
                  //cvEntry.currentJob = true;
                  currentJobSet = true;
                  break;
                }
              }
              if (!currentJobSet) {
                notParseable += `\nDerzeitiger Job: ${cvData.summary.currentJob}\nDerzeitiger Arbeitgeber: ${cvData.summary.currentEmployer}`;
              }
            }
            return cvEntries;
          })
        };
      }
      //console.log(JSON.stringify(this.applicant));
      let applicantCopy = JSON.parse(JSON.stringify(await this.applicant));
      let applicantData = await newApplicantData(cvData);
      applicantCopy.contactData.address = Object.assign(
        applicantData.contactData.address,
        applicantCopy.contactData.address
      );
      applicantCopy.contactData.email =
        applicantCopy.contactData.email || applicantData.contactData.email;
      applicantCopy.contactData.telephone =
        applicantCopy.contactData.telephone ||
        applicantData.contactData.telephone;
      applicantCopy.contactData.telephoneMobile =
        applicantCopy.contactData.telephoneMobile ||
        applicantData.contactData.telephoneMobile;
      console.log(applicantData.contactData, applicantCopy.contactData);
      applicantCopy.contactData = Object.assign(
        applicantData.contactData,
        applicantCopy.contactData
      );
      let applicantUpdate = Object.assign(applicantData, applicantCopy);
      applicantUpdate.profiles[0].cvEntries = await newApplicantProfile(
        cvData,
        applicantUpdate.profiles[0].cvEntries
      ).cvEntries;
      //console.log(applicantUpdate);
      async function addEntry(input, profileId) {
        input.applicantProfileID = profileId;

        await $this.$apollo.mutate({
          mutation: gql`
            mutation($input: CvEntryInput!) {
              createCvEntry(input: $input) {
                id
              }
            }
          `,
          variables: {
            input
          }
        });
      }
      applicantUpdate.profiles[0].internalRatingComment +=
        "<p> <strong>Folgende Daten konnten nicht verarbeitet werden</strong> <br />" +
        notParseable +
        "</p>";
      async function persist(input) {
        let profileId = input.profiles[0].id;
        let profile = Object.prepareGqlInput(input.profiles[0]);
        delete profile["cvEntries"];
        await $this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantProfileInput!) {
                updateApplicantProfile(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: profileId,
              input: profile
            }
          })
          .catch(error => {
            $this.reportUnhandledErrorApplicant(error);
            throw error;
          });

        let id = input.id;
        input = Object.prepareGqlInput(input);
        delete input["profiles"];
        delete input["defaultProfile"];
        delete input["number"];
        delete input["privacyPolicyAcceptedDate"];
        delete input["l1ID"];
        delete input["createdAt"];
        delete input["latestApplication"];

        input.source = applicantSources[input.source] || oldSource || null;
        await $this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantInput!) {
                updateApplicant(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id,
              input
            }
          })
          .then(() => {
            $this.$vs.notify({
              title: "Bewerberdaten aus datei übertragen",
              text:
                "Daten, die nicht verarbeitet werden konntnen finden Sie unter internes in der Bewertung",
              color: "success",
              icon: "query_builder",
              position: "bottom-center"
            });
          })
          .catch(error => {
            $this.reportUnhandledErrorApplicant(error);
          });
      }
      await (async () => {
        //console.log(applicantUpdate);
        for (let cvEntry of applicantUpdate.profiles[0].cvEntries) {
          if (!cvEntry.id) {
            await addEntry(cvEntry, applicantUpdate.profiles[0].id);
          }
        }
      })();
      await persist(applicantUpdate);

      this.cvTransferInProgress = false;
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: ID!) {
              sortCvEntries(profile: $id)
            }
          `,
          variables: {
            id: applicantUpdate.profiles[0].id
          }
        });
      } catch (e) {
        $this.reportUnhandledErrorApplicant(e);
      }
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!) {
            completeDocumentAnalysis(id: $id)
          }
        `,
        variables: {
          id: documentID
        }
      });
      window.location.reload();
    },
    templateChange() {
      var e = document.getElementById("template");
      this.template = e.value;
    },
    getStateColor(name) {
      if (name == "Vertrag") {
        return "green";
      } else if (name == "Kein Status") {
        return "red";
      } else {
        return "yellow";
      }
    },
    getAge(birthday) {
      if (birthday) {
        var age = null;
        age = moment().diff(birthday, "years", false);
        if (age == null) {
          return "";
        } else {
          return `(${age})`;
        }
      }
    },
    showHistoryRoute() {
      this.$router.replace({
        name: "applicant.show.sub",
        params: { page: "history" }
      });
      this.currentTab = this.tabs.indexOf(this.$route.params.page);
    },
    goBack() {
      return this.$router.go(-1);
    },
    async applicantDataForm() {
      await this.$apollo.queries.applicant.refetch();
      let wantedOccupation = "";
      let street = "";
      let zip = "";
      let city = "";
      let email = "";
      let phone = "";
      let mobile = "";
      let birthday = "";
      let birthplace = "";
      let salutation = "";
      let kids = "";
      let civilStatus = "";
      let nationality = "";

      if (this.applicant.defaultProfile.wantedOccupation) {
        wantedOccupation = this.applicant.defaultProfile.wantedOccupation;
      }
      if (
        this.applicant.contactData.address &&
        this.applicant.contactData.address.street
      ) {
        street = this.applicant.contactData.address.street;
      }
      if (
        this.applicant.contactData.address &&
        this.applicant.contactData.address.zip
      ) {
        zip = this.applicant.contactData.address.zip;
      }
      if (
        this.applicant.contactData.address &&
        this.applicant.contactData.address.city
      ) {
        city = this.applicant.contactData.address.city;
      }
      if (this.applicant.contactData.email) {
        email = this.applicant.contactData.email;
      }
      if (this.applicant.contactData.telephone) {
        phone = this.applicant.contactData.telephone;
      }
      if (this.applicant.contactData.telephoneMobile) {
        mobile = this.applicant.contactData.telephoneMobile;
      }
      if (this.applicant.birthday) {
        birthday = this.applicant.birthday;
      }
      if (this.applicant.birthplace) {
        birthplace = this.applicant.birthplace;
      }
      if (this.applicant.salutation) {
        salutation = this.applicant.salutation;
      }
      if (this.applicant.kids) {
        kids = this.applicant.kids;
      }
      if (this.applicant.civilStatus) {
        civilStatus = CivilStatus[this.applicant.civilStatus];
      }
      if (this.applicant.nationality) {
        let $this = this;
        nationality = Countries.filter(function(elem) {
          return elem.code == $this.applicant.nationality;
        })[0].label;
      }
      window.location =
        "https://select-gmbh.de/applicant/pdf/data?job=" +
        encodeURIComponent(wantedOccupation) +
        "&firstName=" +
        encodeURIComponent(this.applicant.firstName) +
        "&lastName=" +
        encodeURIComponent(this.applicant.lastName) +
        "&street=" +
        encodeURIComponent(street) +
        "&zip=" +
        encodeURIComponent(zip) +
        "&city=" +
        encodeURIComponent(city) +
        "&email=" +
        encodeURIComponent(email) +
        "&phone=" +
        encodeURIComponent(phone) +
        "&mobile=" +
        encodeURIComponent(mobile) +
        "&birthday=" +
        encodeURIComponent(birthday) +
        "&birthplace=" +
        encodeURIComponent(birthplace) +
        "&salutation=" +
        encodeURIComponent(salutation) +
        "&kids=" +
        encodeURIComponent(kids) +
        "&civilStatus=" +
        encodeURIComponent(civilStatus) +
        "&nationality=" +
        encodeURIComponent(nationality);

      this.openSelection = false;
    },
    async applicantSkillForm() {
      const profileData = (
        await this.$apollo.query({
          query: gql`
            query ApplicantProfile($id: ID!) {
              applicantProfile(id: $id) {
                id
                skillJobType {
                  id
                }
              }
            }
          `,
          fetchPolicy: "network-only",
          variables: {
            id: this.applicant.defaultProfile.id
          }
        })
      ).data.applicantProfile;

      if (profileData.skillJobType) {
        window.location =
          "https://select-gmbh.de/applicant/pdf/skills?jobtype=" +
          profileData.skillJobType.id;
      } else {
        this.$vs.notify({
          title: "Skillbogen drucken",
          text: "Bitte Berufsbereich hinterlegen!",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center"
        });
      }
      this.openSelection = null;
    },
    async downloadPdf() {
      const applicantData = await this.$apollo.query({
        query: gql`
          query Applicant($id: ID!) {
            applicant(id: $id) {
              id
              number
              salutation
              firstName
              lastName
              civilStatus
              imageID
              birthday
              contactData {
                address {
                  city
                }
              }
              group {
                id
                name
              }
              source {
                id
                name
              }
              entryType {
                id
                name
              }
            }
          }
        `,
        fetchPolicy: "network-only",
        variables: {
          id: this.$route.params.id
        }
      });

      const profileData = await this.$apollo.query({
        query: gql`
          query ApplicantProfile($id: ID!) {
            applicantProfile(id: $id) {
              id
              shortProfileDescription
              showPicture
              exportGender
              exportName
              exportAdress
              exportShortDescription
              exportInternalRating
              exportNegotioation
              exportNameMasking
              internalRatingComment
              wantedOccupation
              mobilityComment
              availibilty {
                id
                name
              }
              availibiltyCustom
              ownCar
              driverLicenses {
                id
                name
              }
              consultant {
                id
                firstName
                lastName
                telephone
                fax
                imageID
                user {
                  id
                  email
                }
              }
              cvEntries {
                id
                type {
                  id
                  name
                }
                branch {
                  id
                  name
                }
                dateUntil
                dateFrom
                employer
                position
                description
              }
              skillJobType {
                id
              }
              wantedJobTypes {
                id
                name
              }
              commissionAmount
            }
          }
        `,
        fetchPolicy: "network-only",
        variables: {
          id: this.currentProfileId
        }
      });

      PdfExport(
        this.$apollo,
        this.$axiosStorageApi,
        applicantData.data.applicant,
        profileData.data.applicantProfile,
        this.template
      );
      this.openSelection = null;
    },
    toggleSelection(name) {
      if (this.openSelection === name) {
        this.openSelection = null;
      } else {
        this.openSelection = name;
      }
    },
    isPv() {
      if (
        this.applicant.defaultProfile.wantedJobTypes.find(o => o.name === "PV")
      ) {
        return true;
      } else {
        return false;
      }
    },
    async saveInterviewData() {
      let input = {
        interviewNote: this.applicant.defaultProfile.interviewNote
      };
      try {
        await this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: NewAction!) {
                createAction(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: {
                description: input.interviewNote,
                done: true,
                refType: "APPLICANT",
                refID: this.applicant.id,
                typeID: "c2f7b164-e23f-4b42-81e5-ce08739d7ba0", //TODO: make this less dependant on the promatch database
                consultantID: this.me.consultant.id,
                title: "Interviewnotiz",
                groupID: this.me.group.id
              }
            }
          })
          .then(() => {
            this.applicant.defaultProfile.interviewNote = null;
          });

        this.reportSuccessApplicant(input); // eslint-disable-line
        this.$vs.notify({
          title: "Notiz gespeichert",
          text: "Notiz wurde erfolgreich gespeichert",
          color: "success",
          icon: "query_builder",
          position: "bottom-center"
        });
      } catch (e) {
        console.log(e);
        this.reportUnhandledErrorApplicant(e);
      }
    },
    formSaved(e) {
      this.$vs.notify({
        title: "Bewerber gespeichert",
        text: "Bewerber wurde erfolgreich gespeichert",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });

      this.lastSave = e;
      this.$apollo.queries["applicant"].refetch();
      this.$apollo.queries["applicantProfile"].refetch();
    }
  }
};
</script>

<style>
#quick-mail {
  position: fixed;
  right: 20px;
  bottom: 25px;
  display: inline-block;
  width: 45px;
  height: 45px;
  line-height: 42px;
  border-radius: 50%;
  text-align: center;
  background-color: #ff9f43;
  cursor: pointer;
  border: 2px solid #ff9f43;
  transition: 0.3s ease all;
  color: white;
  z-index: 500;
}
#quick-mail:hover {
  background-color: white;
  color: #ff9f43;
}

#quick-sms {
  position: fixed;
  right: 20px;
  bottom: 85px;
  display: inline-block;
  width: 45px;
  height: 45px;
  line-height: 42px;
  border-radius: 50%;
  text-align: center;
  background-color: #ff9f43;
  cursor: pointer;
  border: 2px solid #ff9f43;
  transition: 0.3s ease all;
  color: white;
  z-index: 500;
}

#quick-sms:hover {
  background-color: white;
  color: #ff9f43;
}
</style>
